// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Krona+One&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-backdrop.show {
  background: #000000 !important;
  opacity: 0.64 !important;
}

.custom-modal {
  -webkit-backdrop-filter: blur(5px);
          backdrop-filter: blur(5px);
}
.custom-modal .modal-dialog {
  padding: 0 1rem;
  max-width: 58.4rem;
}
@media (max-width: 767px) {
  .custom-modal .modal-dialog {
    max-width: 50rem;
    margin: 0 auto;
  }
}
.custom-modal .modal-content {
  border-radius: 2rem;
  box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.1411764706);
  background: #22283a;
  padding: 4rem;
}
@media (max-width: 767px) {
  .custom-modal .modal-content {
    padding: 2.5rem 1.5rem;
  }
}
.custom-modal .modal-body {
  padding: 0;
}
.custom-modal__action {
  position: absolute;
  top: 2rem;
  right: 2.1rem;
  line-height: 1;
}
@media (max-width: 767px) {
  .custom-modal__action {
    top: 1rem;
    right: 1.5rem;
  }
}
.custom-modal__action svg {
  width: 1.6rem;
  height: 1.6rem;
}
@media (max-width: 767px) {
  .custom-modal__action svg {
    width: 1.4rem;
    height: 1.4rem;
  }
}
.custom-modal__action svg path {
  transition: all ease-in-out 200ms;
  fill: #6d8afa;
  fill-opacity: 1;
}
.custom-modal__action:hover svg path {
  fill-opacity: 1;
  fill: #6d8afa;
}
.custom-modal__header {
  transition: all ease-in-out 200ms;
  padding: 1.4rem 0 2rem;
  text-align: center;
}
@media (max-width: 767px) {
  .custom-modal__header {
    padding: 1rem 0 1.6rem;
  }
}
.custom-modal__header_icon {
  width: 9.5rem;
  margin-bottom: 2rem;
}
@media (max-width: 767px) {
  .custom-modal__header_icon {
    margin-bottom: 0.7rem;
    width: 7rem;
  }
}
.custom-modal__header_icon svg {
  width: 9.5rem;
  height: 9.5rem;
  border-radius: 50%;
}
@media (max-width: 767px) {
  .custom-modal__header_icon svg {
    width: 7rem;
    height: 7rem;
  }
}
.custom-modal__header h2 {
  font-size: 2.6rem;
  font-weight: 400;
  color: #ffffff;
}
@media (max-width: 1679px) {
  .custom-modal__header h2 {
    font-size: 2rem;
  }
}
@media (max-width: 767px) {
  .custom-modal__header h2 {
    font-size: 1.8rem;
  }
}
@media (max-width: 575px) {
  .custom-modal__header h2 {
    font-size: 1.4rem;
  }
}
.custom-modal__header p {
  margin-top: 1.4rem;
  color: #bdbdbd;
  font-size: 1.8rem;
  font-weight: 400;
}
@media (max-width: 767px) {
  .custom-modal__header p {
    font-size: 1.6rem;
    line-height: 1.8rem;
  }
}
@media (max-width: 575px) {
  .custom-modal__header p {
    font-size: 1.2rem;
    margin-top: 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/UI/Modal/CustomModal.scss","webpack://./src/Assets/Theme/_var.scss"],"names":[],"mappings":"AAEA;EACE,8BAAA;EACA,wBAAA;AAAF;;AAGA;EACE,kCAAA;UAAA,0BAAA;AAAF;AAEE;EACE,eAAA;EACA,kBAAA;AAAJ;AAEI;EAJF;IAKI,gBAAA;IACA,cAAA;EACJ;AACF;AAEE;EACE,mBAAA;EACA,wDAAA;EACA,mBCNW;EDOX,aAAA;AAAJ;AAEI;EANF;IAOI,sBAAA;EACJ;AACF;AAEE;EACE,UAAA;AAAJ;AAGE;EACE,kBAAA;EACA,SAAA;EACA,aAAA;EACA,cAAA;AADJ;AAGI;EANF;IAOI,SAAA;IACA,aAAA;EAAJ;AACF;AAEI;EACE,aAAA;EACA,cAAA;AAAN;AAEM;EAJF;IAKI,aAAA;IACA,cAAA;EACN;AACF;AACM;EACE,iCAAA;EACA,aClDE;EDmDF,eAAA;AACR;AAIM;EACE,eAAA;EACA,aC1DE;ADwDV;AAOE;EACE,iCAAA;EACA,sBAAA;EACA,kBAAA;AALJ;AAOI;EALF;IAMI,sBAAA;EAJJ;AACF;AAMI;EACE,aAAA;EACA,mBAAA;AAJN;AAMM;EAJF;IAKI,qBAAA;IACA,WAAA;EAHN;AACF;AAKM;EACE,aAAA;EACA,cAAA;EACA,kBAAA;AAHR;AAKQ;EALF;IAMI,WAAA;IACA,YAAA;EAFR;AACF;AAMI;EACE,iBAAA;EACA,gBAAA;EACA,cClGE;AD8FR;AAMM;EALF;IAMI,eAAA;EAHN;AACF;AAKM;EATF;IAUI,iBAAA;EAFN;AACF;AAIM;EAbF;IAcI,iBAAA;EADN;AACF;AAII;EACE,kBAAA;EACA,cC/GM;EDgHN,iBAAA;EACA,gBAAA;AAFN;AAIM;EANF;IAOI,iBAAA;IACA,mBAAA;EADN;AACF;AAGM;EAXF;IAYI,iBAAA;IACA,gBAAA;EAAN;AACF","sourcesContent":["@import \"../../../Assets/Theme/_var.scss\";\n\n.modal-backdrop.show {\n  background: $black !important;\n  opacity: 0.64 !important;\n}\n\n.custom-modal {\n  backdrop-filter: blur(5px);\n\n  .modal-dialog {\n    padding: 0 1rem;\n    max-width: 58.4rem;\n\n    @media (max-width: 767px) {\n      max-width: 50rem;\n      margin: 0 auto;\n    }\n  }\n\n  .modal-content {\n    border-radius: 2rem;\n    box-shadow: 0px 0px 16px 0px #00000024;\n    background: $secondarybg2;\n    padding: 4rem;\n\n    @media (max-width: 767px) {\n      padding: 2.5rem 1.5rem;\n    }\n  }\n\n  .modal-body {\n    padding: 0;\n  }\n\n  &__action {\n    position: absolute;\n    top: 2rem;\n    right: 2.1rem;\n    line-height: 1;\n\n    @media (max-width: 767px) {\n      top: 1rem;\n      right: 1.5rem;\n    }\n\n    svg {\n      width: 1.6rem;\n      height: 1.6rem;\n\n      @media (max-width: 767px) {\n        width: 1.4rem;\n        height: 1.4rem;\n      }\n\n      path {\n        transition: all ease-in-out 200ms;\n        fill: $primary;\n        fill-opacity: 1;\n      }\n    }\n\n    &:hover {\n      svg path {\n        fill-opacity: 1;\n        fill: $primary;\n      }\n    }\n  }\n\n  &__header {\n    transition: all ease-in-out 200ms;\n    padding: 1.4rem 0 2rem;\n    text-align: center;\n\n    @media (max-width: 767px) {\n      padding: 1rem 0 1.6rem;\n    }\n\n    &_icon {\n      width: 9.5rem;\n      margin-bottom: 2rem;\n\n      @media (max-width: 767px) {\n        margin-bottom: 0.7rem;\n        width: 7rem;\n      }\n\n      svg {\n        width: 9.5rem;\n        height: 9.5rem;\n        border-radius: 50%;\n\n        @media (max-width: 767px) {\n          width: 7rem;\n          height: 7rem;\n        }\n      }\n    }\n\n    h2 {\n      font-size: 2.6rem;\n      font-weight: 400;\n      color: $white;\n\n      @media (max-width: 1679px) {\n        font-size: 2rem;\n      }\n\n      @media (max-width: 767px) {\n        font-size: 1.8rem;\n      }\n\n      @media (max-width: 575px) {\n        font-size: 1.4rem;\n      }\n    }\n\n    p {\n      margin-top: 1.4rem;\n      color: $lightGray;\n      font-size: 1.8rem;\n      font-weight: 400;\n\n      @media (max-width: 767px) {\n        font-size: 1.6rem;\n        line-height: 1.8rem;\n      }\n\n      @media (max-width: 575px) {\n        font-size: 1.2rem;\n        margin-top: 1rem;\n      }\n    }\n  }\n}\n","@import url(\"https://fonts.googleapis.com/css2?family=Krona+One&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\n\n$baseFont: \"Poppins\", sans-serif;\n$baseFont2: \"Krona One\", sans-serif;\n\n$white: #ffffff;\n$black: #000000;\n$primary: #6d8afa;\n$primary2: #6f86de;\n$lightGray: #bdbdbd;\n$lightGray2: #d1d1d1;\n$secondary: #252a3a;\n$secondary2: #232323;\n$secondary3: #a3a3a3;\n$secondary4: #727272;\n$secondary5: #292c2e;\n$secondarybg: #171b27;\n$secondarybg2: #22283a;\n$secondarybg3: #202535;\n$secondarybg4: #172545;\n$borderClr: #262626;\n$borderClr2: #252525;\n$borderClr3: #28343e;\n\n$green: #7bbb3f;\n$blue: #2797d1;\n$red: #c3292d;\n$orange: #f68630;\n$skyblue: #01cde4;\n$yellowdark: #fbbb10;\n$reddark: #e54c40;\n\n$btnGradient: linear-gradient(270deg, #fde679 -0.16%, #f26c33 86.5%);\n\n$gradient: linear-gradient(90.71deg, #6f86de -2.07%, #4b67d1 100%);\n$gradient2: linear-gradient(0deg, rgba(0, 0, 0, 0) -29.92%, #161616 97.38%);\n$gradient3: linear-gradient(90deg, #fde076 1.57%, rgba(242, 107, 51, 0) 101.1%);\n$gradient4: linear-gradient(261.01deg, #212122 2.84%, rgba(0, 0, 0, 0) 165.67%);\n\n$boxShadow: 0 1.2rem 1.6rem -0.4rem rgba(255, 255, 255, 0.2),\n  0 0.4rem 0.6rem -0.2rem rgba(255, 255, 255, 0.15);\n$boxShadow2: 0 1rem 1.4rem rgba(255, 255, 255, 0.06);\n$boxShadow3: inset 3px 17px 37px rgba(3, 3, 3, 0.6),\n  inset 0px 0px 5px rgba(255, 255, 255, 0.1);\n\n// z indexes\n$header: 988;\n$sidebar: $header + 3;\n$sidebar_overlay: $sidebar - 2;\n$modal: 1056;\n$loader: 1090;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
